export default {
  survey: {
    allSurvey: "v1/all_survey",
    surveyGroup: "v1/survey_group",
    surveyGroupId: "v1/survey_group/{0}",
    surveyGroupAzmoon: "v1/survey_group/{0}/azmoon",
    surveyGroupAzmoonId: "v1/survey_group/{0}/azmoon/{1}",
    surveyGroupParvandeh: "v1/survey_group/{0}/parvandeh",
    surveyGroupParvandehArray: "v1/survey_group/{0}/parvandeh-array",
    surveyGroupParvandehId: "v1/survey_group/{0}/parvandeh/{1}",
    surveyGroupParvandehLimit: "v1/survey_group_parvandeh_relation/{0}/limit",
    surveyGroupParvandehLimitArray:
      "v1/survey_group_parvandeh_relation/{0}/limit-array",
    surveyGroupParvandehLimitId:
      "v1/survey_group_parvandeh_relation/{0}/limit/{1}",
    surveyGroupParvandehLimitList:
      "v1/survey_group_parvandeh_relation/{0}/limit",
    surveyGroupTerm: "v1/survey_group/{0}/term",
    surveyGroupTermArray: "v1/survey_group/{0}/term-array",
    surveyGroupTermId: "v1/survey_group/{0}/term/{1}",
    survey: "v1/survey",
    surveyId: "v1/survey/{0}",
    mySurvey: "v1/my_survey",
    mySurveyGroupParvandeh: "v1/my-survey-group/{0}/parvandeh",
    surveyGroupSurvey: "v1/survey_group/{0}/survey",
  },
};
